import React, { ReactElement } from 'react';
import FocusTrap from 'focus-trap-react';
import Close from '@images/svg-icons/close.svg';

type Props = {
    children: React.ReactNode;
    showClosingButton?: boolean
    close: () => void
}

const Modal = (props: Props) : ReactElement => {

    const {
        children,
        showClosingButton = true,
        close
    } = props;

    return (
        <FocusTrap focusTrapOptions={{ fallbackFocus: 'body', allowOutsideClick: true }}>
            <div className="modal">
                <div className="modal-content">
                    {showClosingButton && 
                        <button data-analytics_available_call='0' className="modal-content-close" onClick={close} aria-label="Close modal"><Close width={"14px"} height={"14px"} /></button>
                    }
                    {children}
                </div>                
            </div>
        </FocusTrap>
    )
}

export default Modal;